// External Libraries
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Components
import Button from './common/Button';
import Text from './common/Text';

interface NotFoundProps {
  isAuthenticated: boolean;
}

const NotFound: React.FC<NotFoundProps> = ({ isAuthenticated }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div
      style={{
        textAlign: 'center',
        display: 'grid',
        gap: '20px',
        padding: '40px 40px',
      }}
    >
      <Text className="screen-header">
        Oops! Page not found - {location.pathname}
      </Text>
      <Text className="description">
        Sorry, the page you are looking for doesn&apos;t exist. Here are some
        helpful links:
      </Text>
      <Button
        type="button"
        className="tertiary-button"
        onClick={() => navigate(isAuthenticated ? '/Dashboard' : '/')}
      >
        {isAuthenticated ? 'Go to Dashboard' : 'Go to Home'}
      </Button>
    </div>
  );
};

export default NotFound;
